import Vue from 'vue'
import Banner from "./components/Banner.vue";

import {MediaQueries} from 'vue-media-queries';
const mediaQueries = new MediaQueries();
Vue.use(mediaQueries);

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

// import VueElementLoading from "vue-element-loading";
// Vue.component("VueElementLoading", VueElementLoading);

new Vue({
  el: '#app',
  components: {
    Banner
  },
  mediaQueries: mediaQueries
})



// WEBPACK FOOTER //
// ./src/main.js